import * as React from 'react';

import { Message } from 'models';

export interface PriceMessagesProps {
  priceMessages?: Message[];
}

export const PriceMessages: React.FunctionComponent<PriceMessagesProps> = ({ priceMessages }) => (
  <div className="all-t-padding-one" data-stid="price-messages">
    {priceMessages &&
      priceMessages.length > 0 &&
      priceMessages.map(
        message =>
          message &&
          message.value && (
            <div className="pwa-theme--grey-700 uitk-type-100 uitk-type-regular" key={message.value}>
              {message.value}
            </div>
          )
      )}
  </div>
);
PriceMessages['displayName'] = 'PriceMessages';

export interface NumberOfNightsAndRoomsProps {
  numberOfNightsAndRooms?: string;
}

export const NumberOfNightsAndRooms: React.FunctionComponent<NumberOfNightsAndRoomsProps> = ({ numberOfNightsAndRooms }) =>
  numberOfNightsAndRooms ? (
    <div className="numberOfNightsAndRooms pwa-theme--grey-700 uitk-type-100 uitk-type-regular">{numberOfNightsAndRooms}</div>
  ) : null;
NumberOfNightsAndRooms['displayName'] = 'NumberOfNightsAndRooms';

export interface PriceMessagesContainerProps extends PriceMessagesProps {
  numberOfNightsAndRooms?: string;
}

export const PriceMessagesContainer: React.FunctionComponent<PriceMessagesContainerProps> = props => {
  const { priceMessages, numberOfNightsAndRooms } = props;

  return priceMessages ? <PriceMessages {...{ priceMessages }} /> : <NumberOfNightsAndRooms {...{ numberOfNightsAndRooms }} />;
};
PriceMessagesContainer['displayName'] = 'PriceMessagesContainer';
